export const GET_IMAGES_BEGIN = 'GET_IMAGES_BEGIN'
export const GET_IMAGES_SUCCESS = 'GET_IMAGES_SUCCESS'
export const GET_IMAGES_ERROR = 'GET_IMAGES_ERROR'

export const LIKE_IMAGE = 'LIKE_IMAGE'
export const FAVOURITE_IMAGE = 'FAVOURITE_IMAGE'
export const DISLIKE_IMAGE = 'DISLIKE_IMAGE'
export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const GET_LIMITIMAGES_BEGIN = 'GET_LIMITIMAGES_BEGIN'
export const GET_LIMITIMAGES_SUCCESS = 'GET_LIMITIMAGES_SUCCESS'
export const GET_LIMITIMAGES_ERROR = 'GET_LIMITIMAGES_ERROR'
export const SORT_IMAGES = 'SORT_IMAGES'
export const UPDATE_SORT = 'UPDATE_SORT'
export const UPDATE_FILTERS = 'UPDATE_FILTERS'
export const FILTER_PRODUCTS = 'FILTER_PRODUCTS'

export const GET_SINGLE_PRODUCT_BEGIN = 'GET_SINGLE_PRODUCT_BEGIN'
export const GET_SINGLE_PRODUCT_SUCCESS = 'GET_SINGLE_PRODUCT_SUCCESS'
export const GET_SINGLE_PRODUCT_ERROR = 'GET_SINGLE_PRODUCT_ERROR'
export const LOAD_PRODUCTS = 'LOAD_PRODUCTS'
export const SET_GRIDVIEW = 'SET_GRIDVIEW'
export const SET_LISTVIEW = 'SET_LISTVIEW'
export const SORT_PRODUCTS = 'SORT_PRODUCTS'
export const CLEAR_FILTERS = 'CLEAR_FILTERS'
export const ADD_TO_CART = 'ADD_TO_CART'
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM'
export const TOGGLE_CART_ITEM_AMOUNT = 'TOGGLE_CART_ITEM_AMOUNT'
export const CLEAR_CART = 'CLEAR_CART'
export const COUNT_CART_TOTALS = 'COUNT_CART_TOTALS'
